<template lang="pug">
  .trace-code
    .panel.panel-default
      .panel-heading.panel-title Code Details - {{code}}
        span.pull-right(v-if="shipment")
      .panel-body(v-if="lastEvent")
        .row
          label.col-sm-2 Shipping To
          .col-sm-10
            router-link(v-if="shipment && shipment.targetLocation", :to="{name: 'byPackageType', params: {id: shipment.targetLocation.id}}") {{shipment.targetLocation.name}}
            em.text-muted(v-else) No target location
        .row.pt10
          label.col-sm-2 Last Observation
          .col-sm-10(v-if="lastEvent.location")
            FamFlag(v-if="lastEvent.location.country.code" :code="lastEvent.location.country.code")
            router-link(:to="{name: 'byPackageType', params: {id: lastEvent.location.id}}") {{lastEvent.location.name}}
            span.ml10 {{lastEvent.eventTime | date}}

        .row.pt10(v-if="shipment")
          label.col-sm-2 Status
          .col-sm-10  {{shipment.status}}


      .panel-body(v-else)
        em.text-muted no information

</template>

<script>
import FamFlag from '@/components/common/FamFlag'
import Util from '@/service/Util'
import { dateFilter } from '@/filters/filters'

export default {
  props: {
    lastEvent: {
      type: Object
    },
    shipment: {
      type: Object
    }
  },
  computed: {
    code() {
      return Util.removeUrl(this.$route.params.code)
    }
  },
  components: {
    FamFlag
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/trace/components/CodeDetails.vue